import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Presupuesto`

export function buscarTodos(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${idUsuario}`)
}

export function buscarPorVendedor(idUsuario, buscar) {
  return http.get(`${API_ENDPOINT}/BuscarPorVendedor/${idUsuario}/${buscar}`)
}

export function buscarPorComprador(idUsuario, buscar) {
  return http.get(`${API_ENDPOINT}/BuscarPorComprador/${idUsuario}/${buscar}`)
}

export function buscarPorId(idPresupuesto) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idPresupuesto}`)
}

export function insertar(presupuesto) {
  return http.post(`${API_ENDPOINT}/insertar/`, presupuesto)
}
export function actualizar(presupuesto) {
  return http.put(API_ENDPOINT, presupuesto)
}

export function comprar(presupuesto) {
  return http.post(`${API_ENDPOINT}/comprar/`, presupuesto)
}

export function eliminar(idPresupuesto) {
  return http.delete(API_ENDPOINT, idPresupuesto)
}
